<template>
  <div id="app" class="app-root">
    <div id="scroll-box"></div>
    <template v-if="isReportPage">
      <router-view />
    </template>
    <template v-else>
      <template v-if="['patient-intro'].includes($route.name)">
        <layout-header></layout-header>
      </template>
      <div id="app-container" class="app-container" :style="{ position: modal.action && !isDialogLoading ? 'relative' : 'relative' }">
        <div class="app-pages col-block" :style="{ minHeight: minHeight }">
          <div v-if="currentBackground" class="app-background" :class="{ filter: !isMainPage, cover: isMainPage }" :style="currentBackground"></div>
          <div class="max-width" v-if="!isMainPage" :style="{ flex: 1 }">
            <div class="view-container">
              <div class="view-field responsitive-color transparent-transparent">
                <router-view :minHeight="minHeight" />
              </div>
            </div>
          </div>
          <div class="app-main-container col-block" :style="{ flex: 1 }" v-else>
            <router-view :minHeight="minHeight" />
          </div>
        </div>
      </div>
      <template v-if="!['main'].includes($route.name)">
        <layout-footer></layout-footer>
      </template>
      <div class="modal-container">
        <modal v-if="modal.action" :style="!isDialogLoading ? {} : { display: 'none' }" :width="modal.width" :height="modal.height" :customStyles="modal.customStyles" :maskClose="modal.maskClose" :autoHeight="modal.autoHeight" @hide="() => {
          modal.callback && modal.callback()
          setModalAction({})
        }">
          <component :is="modal.action" :param="modal.param" @changeModal="(option, param) => {
            modal.callback && modal.callback(param)
            this.setModalAction(option || {})
          }"></component>
        </modal>
        <modal v-if="modal2.action" :style="!isDialogLoading ? {} : { display: 'none' }" :width="modal2.width" :height="modal2.height" :customStyles="modal2.customStyles" :maskClose="modal2.maskClose" :autoHeight="modal2.autoHeight" @hide="() => {
          modal2.callback && modal2.callback()
          setModal2Action({})
        }">
          <component :is="modal2.action" :param="modal2.param" @changeModal="(option, param) => {
            modal2.callback && modal2.callback(param)
            this.setModal2Action(option || {})
          }"></component>
        </modal>
      </div>
      <layoutToast></layoutToast>
      <layoutBorCor></layoutBorCor>
      <layoutLoading v-if="isLoading"></layoutLoading>
      <layoutUploading v-if="isUploading !== undefined" :content="isUploading"></layoutUploading>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { getUserToken } from './api'
import layoutHeader from './components/layout/header.vue'
import layoutFooter from './components/layout/footer.vue'
import layoutToast from './components/layout/toast.vue'
import layoutBorCor from './components/layout/borCor.vue'
import layoutLoading from './components/layout/loading.vue'
import layoutUploading from './components/layout/uploading.vue'
import responsitive from './mixins/responsitive.vue'
import toastMethods from './mixins/toastMethods.vue'
import loginData from './mixins/loginData.vue'
// modals
import modal from './components/dialog/container.vue'
import login from './components/dialog/login.vue'
import toast from './components/dialog/toast.vue'

require('font-awesome-sass-loader')

export default {
  name: 'app',
  components: {
    layoutHeader,
    layoutFooter,
    layoutToast,
    layoutBorCor,
    layoutLoading,
    layoutUploading,
    // modals
    modal,
    login,
    toast
  },
  mixins: [
    responsitive,
    loginData,
    toastMethods
  ],
  metaInfo () {
    return {
      title: '康百事生物資訊'/* ___ */
    }
  },
  data () {
    return {
      userAgent: '',
      minHeight: '300px'
    }
  },
  watch: {
    '$route' () {
      const { body } = document
      body.scroll(0, 0)
      this.setModalAction({})
      this.setModal2Action({})
      this.clearSubLoadingAction()
      window.dispatchEvent(new Event('resize'))
      if (this.initial !== null) {
        this.setLoadingAction(true)
        this.validateRoute(this.isLogin, (this.user || {}).role)
      }
    },
    async 'isLogin' (n, o) {
      if (o !== null) {
        this.setLoadingAction(true)
        await this.preFetchDataGuest()
        if (n) {
          await this.preFetchData()
        } else {
          this.setUnloadAlertAction()
        }
        this.appInitialAction(n)
        this.setLoadingAction(false)
      }
    },
    'unloadAlert' (nv) {
      if (nv) {
        window.document.body.onbeforeunload = function () { return '' }
      } else {
        window.document.body.onbeforeunload = null
      }
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'normalPage',
      'userPage',
      'initial',
      'isLogin',
      'isLoading',
      'isDialogLoading',
      'isUploading',
      'modal',
      'modal2',
      'unloadAlert'
    ]),
    currentBackground () {
      let currentBackground = {
      }[this.$route.name]
      return currentBackground ? { 'background-image': 'url(' + currentBackground.url + ')', ...currentBackground.style } : null
    },
    isMainPage () {
      return this.$route.name && [
        // normal
        'main',
        //
        ''
      ].includes(this.$route.name)
    },
    isReportPage () {
      return this.$route.name && [
        'report',
        //
        ''
      ].includes(this.$route.name)
    }
  },
  created () {
    this.userAgent = navigator.userAgent
    this.setModalAction({})
    this.setModal2Action({})
    this.setLoadingAction(true)
    const validateLogin = () => {
      if (this.$route.name) {
        this.validateLogin()
      } else {
        setTimeout(() => validateLogin(), 100)
      }
    }
    validateLogin()
  },
  beforeMount () {
    const { body } = document
    const handler = () => {
      if (!document.hidden) {
        let rect = body.getBoundingClientRect()
        let headerHeight = 50
        let footerHeight = this.isMobile ? 133 : 30
        let height = rect.height - headerHeight - footerHeight + 0
        this.minHeight = height + 'px'
      }
    }
    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
  },
  mounted () {
    window.addEventListener('scroll', () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      let offsetHeight = document.documentElement.offsetHeight || document.body.offsetHeight
      this.setScrollStateAction({
        top: scrollTop,
        height: scrollHeight - offsetHeight
      })
    })
  },
  methods: {
    ...mapActions([
      'appInitialAction',
      'setLoadingAction',
      'setDialogLoadingAction',
      'clearLoadingAction',
      'clearSubLoadingAction',
      'clearDialogLoadingAction',
      'setModalAction',
      'setModal2Action',
      'setUnloadAlertAction',
      'setScrollStateAction'
      // global
    ]),
    async preFetchDataGuest () {
    },
    async preFetchData () {
    },
    async validateLogin () {
      let userInfo = this.$ls.get('userInfo') || {}
      await this.preFetchDataGuest()
      if (userInfo['access-token']) {
        await this.getUserByToken(userInfo)
      } else {
        this.setUserData(null)
        this.appInitialAction(false)
        this.validateRoute(false)
      }
    },
    async getUserByToken (data) {
      try {
        let response = await getUserToken(data)
        await this.preFetchData()
        let user = response.data.user || { role: {} }
        this.setUserData(response, data)
        this.appInitialAction(true)
        this.validateRoute(true, user.role.name, user.admin)
      } catch (error) {
        this.setUserData(null)
        this.appInitialAction(true)
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        this.validateRoute(false)
      }
    },
    validateRoute (isLogin, role, admin) {
      let array = []
      if (isLogin) {
        switch (role) {
          default: {
            array = _.union(this.userPage, this.normalPage)
          }
        }
      } else {
        array = this.normalPage
      }
      if (admin) {
        array = _.union(array, this.adminPage)
      }
      this.validateRole(isLogin, array)
    },
    validateRole (isLogin, pages) {
      let routeName = this.$route.name
      if (routeName && !_.includes(pages, routeName)) {
        this.addToast('error', isLogin ? this.$t('COMMON.toast.___noPermission'/* 權限不足 */) : this.$t('COMMON.toast.___pleaseLogin'/* 請先登入 */))
        this.$router.push({ name: !isLogin ? 'main' : 'main' })
        this.setLoadingAction(false)
      } else {
        if (isLogin && _.includes(this.normalPage, routeName) && routeName !== 'redirect') {
          this.$router.push({ name: 'main' })
        }
        this.setLoadingAction(false)
      }
    }
  }
}
</script>

<style lang="sass">
@import sass/style
</style>



// WEBPACK FOOTER //
// src/App.vue